<div class="progress">
    <ng-template ngFor let-breadcrumb [ngForOf]="breadcrumbs">
        <div class="progress-item" [ngClass]="'progress-' + breadcrumb.percent" [class.active]="percent == breadcrumb.percent">
            <ng-container *ngIf="percent >= breadcrumb.percent">
                <div class="percent">{{ breadcrumb.percent }}%</div>
                <div class="breadcrumb d-none d-md-block" [innerHTML]="breadcrumb.title | translate"></div>
            </ng-container>
        </div>
    </ng-template>
</div>
